'use client'

import { useEffect } from 'react'
import { getTrackingService } from '@/services/tracking/TrackingInstance'
import { Device } from '@/utils/app/detect'

export function ClientPageTracking({
  isRoot,
  dv,
}: {
  isRoot: boolean
  dv: Device
}) {
  useEffect(() => {
    if (isRoot) {
      const trackingService = getTrackingService()
      trackingService.addAndExecuteCommand('page-setup', {
        emsZone: 'homepage',
        envTemplate: 'home',
        ivwLvl2: 'home',
        pageContext: '47823 (Relaunch 2013)',
        pagePath: '/relaunch-2013',
        agofCode: 'dbrhowf_tak_wehome',
        device: dv,
      })
    }
  }, [isRoot, dv])

  return null
}
